import { BFF_API_ROUTES } from 'constants/routes';

import { baseRTKApi } from 'shared/api/baseApi';
import { sendSentryClientErrorOnce } from 'shared/lib';
import type { TAutoInfo } from 'shared/types';

export const autoQueries = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getCarInfo: build.query<TAutoInfo | null, string>({
      async queryFn(autoNumber, _queryApi, _extraOptions, fetchQuery) {
        if (autoNumber.length < 3) {
          return { data: null };
        }

        const result = await fetchQuery({
          url: BFF_API_ROUTES.getCarInfo,
          method: 'POST',
          body: { number: autoNumber },
        });

        if (result.error) {
          sendSentryClientErrorOnce('Ошибка при вызове getCarInfo', JSON.stringify(result.error.data), {
            number: autoNumber,
            level: 'log',
          });
          return { data: null };
        }

        return { data: result.data as TAutoInfo };
      },
      keepUnusedDataFor: 10 * 60,
      extraOptions: { maxRetries: 3 },
    }),
  }),
});
